export const dev = {
    auth0: {
        domain: 'dev-crew-time.eu.auth0.com',
        clientId: '7FEiQOsioO3peLCxvQNJ4CONqepXEGrz',
        audience: 'https://crew-time/api',
    }
}

export const prod = {
    auth0: {
        domain: 'dev-crew-time.eu.auth0.com',
        clientId: '7FEiQOsioO3peLCxvQNJ4CONqepXEGrz',
        audience: 'https://crew-time/api',
    }
}